import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Box } from '@mui/material';

import { useAuthStore } from '@features/auth';

import Image from '/bg2.jpg';

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ params }) => {
    const accessToken = useAuthStore.getState().accessToken;

    if (accessToken) {
      // Staff users go to the staff dashboard
      const isStaff = useAuthStore.getState().isStaff;
      if (isStaff) {
        throw redirect({ to: '/staff' });
      }
      // If user is already logged in, redirect to the venue dashboard
      // or homepage if no venue in URL
      const venueSlug = (params as { venueSlug?: string }).venueSlug;
      if (venueSlug) {
        throw redirect({
          to: '/$venueSlug',
          params: { venueSlug },
        });
      }
      throw redirect({
        to: '/',
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Box
      sx={{
        height: '1000px',
        backgroundColor: 'primary.light',
        backgroundImage: `url(${Image})`,
        backgroundSize: 'cover',
      }}
    >
      <Outlet />
    </Box>
  );
}
